import {
  BlockTop,
  GridPresetOneHalf,
  GridPresetOneThird,
  GridPresetWideContent,
  GridRow,
  TeaserItem,
} from "/App.Components";
import "./TeaserBlock.scss";
import { RowSpacing } from "/Components/Layout/GridRow/GridRow";
import { createSpreadableBem } from "/Helpers/createBem";
import { Columns } from "/Models/Generated/Columns";
import { DesignTheme } from "/Models/Generated/DesignTheme";
import { InsightContext } from "/Models/Generated/InsightContext";
import { TeaserBlockProps } from "/Models/Generated/TeaserBlockProps";

const getColumnCount = (columns: Columns, count: number) => {
  if (columns === Columns.Three) return 3;
  if (columns === Columns.Two) return 2;
  if ([2, 4, 7, 8].includes(count)) return 2;
  if ([3, 5, 6, 9].includes(count)) return 3;
  return 1;
};

const TeaserBlock = ({
  heading,
  headingPropertyName,
  linkToAllArticles,
  linkToAllArticlesPropertyName,
  items,
  columns,
  theme,
  insightContext,
}: TeaserBlockProps) => {
  const sideBar =
    theme === DesignTheme.Insight && insightContext === InsightContext.Article;
  const columnCount = sideBar ? 1 : getColumnCount(columns, items.length);
  const GridPreset = [
    GridPresetWideContent,
    GridPresetOneHalf,
    GridPresetOneThird,
  ][columnCount - 1];

  const bem = createSpreadableBem("teaser-block-norad");

  const useH2ForItems = !heading;

  if (sideBar) {
    return (
      <section {...bem("")}>
        {heading && (
          <BlockTop
            heading={heading}
            headingPropertyName={headingPropertyName}
            link={linkToAllArticles}
            linkPropertyName={linkToAllArticlesPropertyName}
          />
        )}
        {items.map((item, idx) => (
          <TeaserItem
            key={idx}
            {...item}
            wide={true}
            useH2={useH2ForItems}
            theme={theme}
            insightContext={insightContext}
            sidebar={true}
            isFirst={idx === 0}
          />
        ))}
      </section>
    );
  }
  return (
    <section {...bem("")}>
      {(heading || headingPropertyName) && items.length !== 0 && (
        <GridRow>
          <GridPresetWideContent>
            <BlockTop
              heading={heading}
              headingPropertyName={headingPropertyName}
              link={linkToAllArticles}
              linkPropertyName={linkToAllArticlesPropertyName}
            />
          </GridPresetWideContent>
        </GridRow>
      )}
      {GridPreset && items.length > 0 && (
        <GridRow
          rowSpacing={RowSpacing.s}
          rowSpacingMobileUp={RowSpacing.xxl}
          rowSpacingTabletUp={RowSpacing.xl}
        >
          {items.map((item, idx) => (
            <GridPreset key={idx}>
              <TeaserItem
                {...item}
                wide={columnCount === 1}
                medium={columnCount === 2}
                useH2={useH2ForItems}
                theme={theme}
                insightContext={insightContext}
              />
            </GridPreset>
          ))}
        </GridRow>
      )}
    </section>
  );
};

export default TeaserBlock;
